import { useQuery } from '@tanstack/react-query';
import { makeDashboardApi } from '../DashboardApi';
import { AxiosError, AxiosResponse } from 'axios';
import { ISalesMetricsFiltersRequest, ISalesMetricsFiltersResponse } from '../types';

export const useSalesMetricsFilterOptions = (request: ISalesMetricsFiltersRequest) => {
  const salesMetricsFilterOptions = useQuery<AxiosResponse<ISalesMetricsFiltersResponse>, AxiosError>({
    queryKey: ['sales-metrics-filters', request],
    queryFn: () => {
      return makeDashboardApi().getSalesMetricsFilters(request);
    },
    retry: false,
  });

  return {
    salesMetricsFilterOptions: salesMetricsFilterOptions.data?.data,
    isLoadingSalesMetricsFilterOptions: salesMetricsFilterOptions.isLoading,
    isErrorSalesMetricsFilterOptions: salesMetricsFilterOptions.error,
  };
};
